import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

function PerfilUsuario({ usuario, onClose }) {
  const [passwordActual, setPasswordActual] = useState('');
  const [passwordNueva, setPasswordNueva] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleCambiarPassword = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (passwordNueva !== passwordConfirm) {
      setError('Las contraseñas nuevas no coinciden');
      return;
    }

    if (passwordNueva.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API_URL}/auth/cambiar-password`, {
        usuarioId: usuario.id,
        passwordActual,
        passwordNueva
      });

      setSuccess('Contraseña actualizada correctamente');
      
      // Limpiar campos
      setPasswordActual('');
      setPasswordNueva('');
      setPasswordConfirm('');
      
      setTimeout(() => {
        setSuccess(null);
      }, 3000);
    } catch (error) {
      console.error('Error al cambiar contraseña:', error);
      setError(
        error.response?.data?.error || 'Error al cambiar contraseña'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#fff',
        padding: '32px',
        borderRadius: '12px',
        maxWidth: '600px',
        width: '90%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
      }}>
        <h2 style={{ marginBottom: '24px', color: '#212121' }}>
          Mi Perfil
        </h2>

        {/* Información del Usuario */}
        <div style={{
          padding: '20px',
          background: '#F5F5F5',
          borderRadius: '8px',
          marginBottom: '24px'
        }}>
          <h3 style={{ marginBottom: '16px', color: '#424242', fontSize: '18px' }}>
            Información Personal
          </h3>
          <div style={{ display: 'grid', gap: '12px' }}>
            <div>
              <strong>Nombre:</strong> {usuario.nombreCompleto || `${usuario.nombre} ${usuario.apellido}`}
            </div>
            <div>
              <strong>Email:</strong> {usuario.email}
            </div>
            <div>
              <strong>DNI:</strong> {usuario.dni}
            </div>
            <div>
              <strong>Tipo:</strong> {
                usuario.tipo_usuario === 'super_admin' ? 'Super Administrador' :
                usuario.tipo_usuario === 'admin' ? 'Administrador' :
                usuario.tipo_usuario === 'encargado' ? 'Encargado de Sede' :
                'Empleado'
              }
            </div>
            {usuario.sede && (
              <div>
                <strong>Sede:</strong> {usuario.sede.nombre}
              </div>
            )}
            {usuario.sector && (
              <div>
                <strong>Sector:</strong> {usuario.sector.nombre}
              </div>
            )}
          </div>
        </div>

        {/* Cambiar Contraseña */}
        <div style={{
          padding: '20px',
          background: '#FFF3E0',
          borderRadius: '8px',
          border: '1px solid #FFB74D'
        }}>
          <h3 style={{ marginBottom: '16px', color: '#424242', fontSize: '18px' }}>
            Cambiar Contraseña
          </h3>

          {error && (
            <div className="alert alert-danger" style={{ marginBottom: '16px' }}>
              {error}
            </div>
          )}

          {success && (
            <div className="alert alert-success" style={{ marginBottom: '16px' }}>
              {success}
            </div>
          )}

          <form onSubmit={handleCambiarPassword}>
            <div className="form-group" style={{ marginBottom: '16px' }}>
              <label style={{ fontWeight: 500, color: '#212121', marginBottom: '8px', display: 'block' }}>
                Contraseña Actual
              </label>
              <input
                type="password"
                className="form-control"
                value={passwordActual}
                onChange={(e) => setPasswordActual(e.target.value)}
                placeholder="••••••••"
                required
                disabled={loading}
                style={{ 
                  padding: '12px 16px',
                  fontSize: '16px',
                  borderRadius: '8px',
                  width: '100%'
                }}
              />
            </div>

            <div className="form-group" style={{ marginBottom: '16px' }}>
              <label style={{ fontWeight: 500, color: '#212121', marginBottom: '8px', display: 'block' }}>
                Nueva Contraseña
              </label>
              <input
                type="password"
                className="form-control"
                value={passwordNueva}
                onChange={(e) => setPasswordNueva(e.target.value)}
                placeholder="••••••••"
                required
                disabled={loading}
                minLength={6}
                style={{ 
                  padding: '12px 16px',
                  fontSize: '16px',
                  borderRadius: '8px',
                  width: '100%'
                }}
              />
              <small style={{ color: '#757575', fontSize: '12px' }}>
                Mínimo 6 caracteres
              </small>
            </div>

            <div className="form-group" style={{ marginBottom: '16px' }}>
              <label style={{ fontWeight: 500, color: '#212121', marginBottom: '8px', display: 'block' }}>
                Confirmar Nueva Contraseña
              </label>
              <input
                type="password"
                className="form-control"
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
                placeholder="••••••••"
                required
                disabled={loading}
                style={{ 
                  padding: '12px 16px',
                  fontSize: '16px',
                  borderRadius: '8px',
                  width: '100%'
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: 'none',
                background: '#27AE60',
                color: '#fff',
                fontSize: '16px',
                fontWeight: 600,
                cursor: loading ? 'not-allowed' : 'pointer'
              }}
            >
              {loading ? 'Guardando...' : 'Actualizar Contraseña'}
            </button>
          </form>
        </div>

        {/* Botón Cerrar */}
        <div style={{ marginTop: '24px', textAlign: 'center' }}>
          <button
            onClick={onClose}
            style={{
              padding: '12px 32px',
              borderRadius: '8px',
              border: '1px solid #E0E0E0',
              background: '#fff',
              color: '#616161',
              fontSize: '16px',
              fontWeight: 500,
              cursor: 'pointer'
            }}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}

export default PerfilUsuario;
